import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout } from 'antd';
const { Header, Content, Sider } = Layout;
// Wrapper component to handle React type version conflicts
const ReactNodeWrapper = ({ children }) => {
    return _jsx(_Fragment, { children: children });
};
export const ResponsiveLayout = ({ children, header, sidebar, collapsed = false, onCollapse, }) => {
    return (_jsxs(Layout, { style: { minHeight: '100vh' }, children: [sidebar && (_jsx(Sider, { trigger: null, collapsible: true, collapsed: collapsed, onCollapse: onCollapse, style: {
                    overflow: 'auto',
                    height: '100vh',
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    bottom: 0,
                }, children: _jsx(ReactNodeWrapper, { children: sidebar }) })), _jsxs(Layout, { style: { marginLeft: collapsed ? 80 : 200 }, children: [header && _jsx(Header, { children: _jsx(ReactNodeWrapper, { children: header }) }), _jsx(Content, { style: { padding: '24px' }, children: _jsx(ReactNodeWrapper, { children: children }) })] })] }));
};
export default ResponsiveLayout;
//# sourceMappingURL=ResponsiveLayout.js.map